import { edi } from '@/requests';
import { postRequest } from '@/core';

export default async function scheduleSuborderOnTransporterOrderRequest(transporterOrderId, subOrderId) {
	let url = edi.scheduleSingleOrderOnTransporter(transporterOrderId, subOrderId);
	let response = await postRequest(url, {}, {});
	return response;
}